/* eslint-disable import/prefer-default-export */
export const paragraphObjectBackground = `
... on ParagraphObjectBackground {
  fieldObjectImg:fieldObjectImgMedia {
      entity {
        ... on MediaImage {
            fieldMediaImage {
                width
                height
                url
                alt
                title
            }
        }
      }
  }
  fieldVarDarkOverlay
  fieldColorBackground
  fieldVarBackgroundOpacity
}
`;

export const fieldObjectSectionStyle = `
entity {
  ... on Paragraph {
    ... on ParagraphObjectSectionStyle {
      fieldCssId
      fieldColorText
      fieldObjectBackground {
          entity {
            ... on Paragraph {
              ${paragraphObjectBackground}
            }  
        }
      }
      fieldVarTextAlignment
      fieldVarAdditionalCss
    }
  }
}
`;



// WEBPACK FOOTER //
// ./frontend/helpers/graphQLShortcuts.js